"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCloseFrameMessageReceived = exports.closeReasonToCloseReasonType = void 0;
var tslib_1 = require("tslib");
var bi_logger_1 = require("./bi-logger");
var user_feedback_common_1 = require("@wix/user-feedback-common");
var constants_1 = require("../constants");
function closeReasonToCloseReasonType(reason) {
    switch (reason) {
        case user_feedback_common_1.CloseReason.Canceled:
            return constants_1.CloseReasonType.Canceled;
        case user_feedback_common_1.CloseReason.FinishedFlow:
            return constants_1.CloseReasonType.FinishedFlow;
        case user_feedback_common_1.CloseReason.CanceledDueToError:
            return constants_1.CloseReasonType.CanceledDueToError;
        default:
            return constants_1.CloseReasonType.Canceled;
    }
}
exports.closeReasonToCloseReasonType = closeReasonToCloseReasonType;
exports.trackCloseFrameMessageReceived = function (params) {
    // tslint:disable-next-line no-floating-promises
    bi_logger_1.biLogger.log(tslib_1.__assign(tslib_1.__assign({}, params), { evid: 846 }));
};
//# sourceMappingURL=track-close-frame-message-recieved.js.map